@if (error()) {
  <div class="alert alert-danger mt-3 text-break">
    <span class="material-icons-outlined me-2">error</span>
    @if (
      errorObject()!.status &&
      errorObject()!.status !== '0' &&
      !errorObject()!.message
    ) {
      <strong>{{ errorObject()!.status }}:</strong>
    }
    <span>&nbsp;</span>
    @let translatedMessage =
      errorObject().message
        | translate: { fallbackMessage: errorObject().fallbackMessage };
    <span>{{
      translatedMessage === errorObject().message &&
      errorObject().fallbackMessage
        ? errorObject().fallbackMessage
        : translatedMessage
    }}</span>
    <br />
    @if (errorObject()!.validationErrors?.length) {
      <span class="mt-2">
        <strong>{{ 'Validation Errors:' | translate }}</strong
        >&nbsp;{{ errorObject()!.validationErrors }}
      </span>
    }
  </div>
}
